import {
  AUTHENTICATING_USER_REQUEST, AUTHENTICATING_USER_SUCCEDDED, AUTHENTICATING_USER_FAILED,
  FETCHING_SSO_URL_REQUEST, FETCHING_SSO_URL_SUCCEEDED, FETCHING_SSO_URL_FAILED,
  SSO_AUTHENTICATION_FAILED, LOGOUT_USER_REQUEST, LOGOUT_USER,
  FETCHING_USER_PROFILE, FETCHING_USER_PROFILE_SUCCEEDED, FETCHING_USER_PROFILE_FAILED,
  UPDATING_USER_PROFILE, UPDATING_USER_PROFILE_FAILED, UPDATING_USER_PROFILE_SUCCEEDED,
  FORGOT_PASSWORD_FAILED, FORGOT_PASSWORD_REQUEST, FORGOT_PASSWORD_SUCCEEDED,
  VALIDATING_PASSWORD_RESET_LINK, VALIDATING_PASSWORD_RESET_LINK_SUCCEDDED, VALIDATING_PASSWORD_RESET_LINK_FAILED,
  CHANGING_PASSWORD, CHANGING_PASSWORD_SUCCEEDED, CHANGING_PASSWORD_FAILED, 
  RESET_PASSWORD_REQUEST, RESET_PASSWORD_SUCCEEDED, RESET_PASSWORD_FAILED,
  FETCHING_USER_INVITATION, FETCHING_USER_INVITATION_SUCCEDDED, FETCHING_USER_INVITATION_FAILED,
  USER_REGISTRATION_REQUEST, USER_REGISTRATION_SUCCEDDED, USER_REGISTRATION_FAILED
} from "constants/actionTypes.jsx";

import { createAction } from "redux-actions";
import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import buildUrl from "build-url";

import AuthService from "services/auth.service";
import AsyncLocalStorageService from "services/localstorage.async.service";
import { MIXPANEL_USER_LOGIN } from "constants/mixpanelEvents";
import { createMixpanelEvent } from "./mixpanel";

const apiUrl = process.env.REACT_APP_PAPERFLITE_API_URL;
const cleverstoryApiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;

const AUTHORIZE_URL = `${apiUrl}/oauth/token`;
const PROFILE_URL = `${apiUrl}/api/2.0/users/me`;
const SSO_URL = `${apiUrl}/api/2.0/users/sso/initiate`;
const LOGOUT_URL = `${apiUrl}/api/2.0/users/logout`;
const CHANGE_PASSWORD_URL = `${apiUrl}/api/2.0/users/change-password`;

const USER_BASE_URL = `${apiUrl}/api/2.0/users`;
const WORKSPACE_BASE_URL = `${cleverstoryApiUrl}/api/2.0/workspaces`;
const FORGOT_PASSWORD_URL = `${WORKSPACE_BASE_URL}/forgot-password`;

/**
 * Authanticate User
 */
export const authenticateUser = createAction(
  AUTHENTICATING_USER_REQUEST,
  (username, password) => {
    return { username, password };
  }
);

export const authenticatingUserSucceeded = createAction(
  AUTHENTICATING_USER_SUCCEDDED,
  (response) => {
    return response;
  }
);

const authenticateUserFailed = createAction(
  AUTHENTICATING_USER_FAILED,
  (error) => {
    return error;
  }
);

function* authenticateUserSaga(action) {
  const data = {
    grant_type: "password",
    scope: "write",
    username: action.payload.username,
    password: action.payload.password,
  };

  const authorization = btoa("paperflite:paperflite-secret");

  const authenticateUserAPI = () => {
    return axios
      .post(AUTHORIZE_URL, data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Basic ${authorization}`,
        },
        params: data,
      })
      .then((response) => response.data);
  };

  try {
    const response = yield call(authenticateUserAPI);
    AuthService.saveToken(response.access_token, response.refresh_token);
    yield put(authenticatingUserSucceeded(response));

    yield put(createMixpanelEvent(MIXPANEL_USER_LOGIN, {}))

  } catch (error) {
    yield put(authenticateUserFailed(error));
  }
}

/**
 * Fetch SSO URL for email
 *
 */
export const fetchSSOUrlFromEmail = createAction(
  FETCHING_SSO_URL_REQUEST,
  (email) => {
    return { email };
  }
);

export const ssoAuthenticationFailed = createAction(
  SSO_AUTHENTICATION_FAILED,
  (reason) => {
    return { reason };
  }
);

const fetchingSSOUrlSuccedded = createAction(FETCHING_SSO_URL_SUCCEEDED);
const fetchingSSOUrlFailed = createAction(FETCHING_SSO_URL_FAILED);

function* fetchSSOUrlFromEmailSaga(action) {
  let url = buildUrl(SSO_URL, {
    queryParams: {
      email: action.payload.email,
    },
  });

  const fetchSSOUrlFromEmailAPI = () => {
    return axios.get(url).then((response) => response.data);
  };

  try {
    const response = yield call(fetchSSOUrlFromEmailAPI);
    yield put(fetchingSSOUrlSuccedded(response));
  } catch (error) {
    yield put(fetchingSSOUrlFailed(error));
  }
}

/**
 * Change password
 */

export const changePassword = createAction(
  CHANGING_PASSWORD,
  (oldPassword, newPassword1, newPassword2, callback) => {
    return {
      oldPassword: oldPassword,
      newPassword1: newPassword1,
      newPassword2: newPassword2,
      callback: callback,
    };
  }
);

const changePasswordSucceeded = createAction(
  CHANGING_PASSWORD_SUCCEEDED,
  (response) => {
    return response;
  }
);

const changePasswordFailed = createAction(CHANGING_PASSWORD_FAILED, (error) => {
  return error;
});

function* changePasswordSaga(action) {
  var { oldPassword, newPassword1, newPassword2, callback } = action.payload;

  const data = {
    oldPassword: oldPassword,
    newPassword1: newPassword1,
    newPassword2: newPassword2,
  };

  const changePasswordAPI = () => {
    return axios
      .put(CHANGE_PASSWORD_URL, data)
      .then((response) => response.data);
  };

  try {
    const response = yield call(changePasswordAPI);
    yield put(changePasswordSucceeded(response));
    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(changePasswordFailed(error));
  }
}

/*
 * Forgot password Request
 */
export const forgotPassword = createAction(FORGOT_PASSWORD_REQUEST, (email, callback) => {
    return {
      email: email,
      callback: callback,
    };
  }
);

const forgotPasswordSucceeded = createAction(FORGOT_PASSWORD_SUCCEEDED, (response) => {
    return {
      payload: response,
    };
  }
);

const forgotPasswordFailed = createAction(FORGOT_PASSWORD_FAILED, (error) => {
  return {
    payload: error,
  };
});

function* forgotPasswordSaga(action) {
  const { email, callback } = action.payload;

  var data = {
    email: email,
  };

  const forgotPasswordAPI = () => {
    return axios
      .get(FORGOT_PASSWORD_URL, { params: data })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        throw err;
      });
  };

  try {
    const response = yield call(forgotPasswordAPI);
    if (response) {
      yield put(forgotPasswordSucceeded(response));
      callback(response);
    }
  } catch (error) {
    yield put(forgotPasswordFailed(error));
  }
}

/**
 *   check password recovery url
 */

export const validatingRecoveryLink = createAction(VALIDATING_PASSWORD_RESET_LINK, (id, recoveryKey) => {
    return {
      id: id,
      recoveryKey: recoveryKey
    };
  }
);

const validatingRecoveryLinkSuccedded = createAction(
  VALIDATING_PASSWORD_RESET_LINK_SUCCEDDED,
  (json) => {
    return {
      payload: json,
    };
  }
);

const validatingRecoveryLinkFailed = createAction(
  VALIDATING_PASSWORD_RESET_LINK_FAILED,
  (error) => {
    return {
      payload: error,
    };
  }
);

function* validateRecoveryLinkSaga(action) {
  const { id, recoveryKey } = action.payload;

  let url = buildUrl(WORKSPACE_BASE_URL, {
    path: `${id}/reset-password?key=${recoveryKey}`
  });

  const validateRecoveryLinkAPI = () => {
    return axios
      .get(url)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        throw err;
      });
  };

  try {
    const response = yield call(validateRecoveryLinkAPI);
    if (response) {
      yield put(validatingRecoveryLinkSuccedded(response));
      // callback(response);
    }
  } catch (error) {
    yield put(validatingRecoveryLinkFailed(error));
  }
}

/**
 *   Reset Password
 */

export const resetPassword = createAction(RESET_PASSWORD_REQUEST, (id, request, callback) => {
  return {
    id: id,
    request: request,
    callback: callback
  };
});

const resetingPasswordSuccedded = createAction(RESET_PASSWORD_SUCCEEDED, (json) => {
    return {
      payload: json,
    };
  }
);

const resetingPasswordFailed = createAction(RESET_PASSWORD_FAILED, (error) => {
  return error;
});

function* resetPasswordSaga(action) {
  var { id, request, callback } = action.payload;

  let url = buildUrl(USER_BASE_URL, {
    path: `${id}/reset-password`
  })

  const resetPasswordAPI = () => {
    return axios
      .put(url, request)
      .then((response) => response.data);
  };
  try {
    const response = yield call(resetPasswordAPI);
    yield put(resetingPasswordSuccedded(response));
    if(callback) {
      callback(response);
    }
  } catch (error) {
    yield put(resetingPasswordFailed(error.errors));
  }
}

/**
 *   fetch User Invitation
 */
export const fetchUserInvitation = createAction(FETCHING_USER_INVITATION, (id, invitationKey) => {
  return {
    id: id,
    invitationKey: invitationKey
  };
});

const fetchingUserInvitationSuccedded = createAction(FETCHING_USER_INVITATION_SUCCEDDED, (response) => {
  return response;
});

const fetchingUserInvitationFailed = createAction(FETCHING_USER_INVITATION_FAILED, (error) => {
  return error
});

function* fetchUserInvitationSaga(action) {
  const { id, invitationKey } = action.payload;

  const params = {
    invitation_token: invitationKey,
  };

  const fetchInvitationAPI = () => {
    return axios({
      method: "GET",
      url: WORKSPACE_BASE_URL + `/${id}/accept`,
      params: params,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchInvitationAPI);
    yield put(fetchingUserInvitationSuccedded(response));
  } catch (error) {
    yield put(fetchingUserInvitationFailed(error.errors));
  }
}

/**
 *  Invite User Registration
 */
export const registerInviteUser = createAction(USER_REGISTRATION_REQUEST, (id, user, callback) => {
  return {
    id: id,
    user: user,
    callback: callback
  };
});

const registeringInviteUserSuccedded = createAction(USER_REGISTRATION_SUCCEDDED, (response) => {
  return response;
});

const registeringInviteUserFailed = createAction(USER_REGISTRATION_FAILED, (error) => {
  return error;
});

function* registerInviteUserSaga(action) {
  const { id, user, callback} = action.payload;

  let url = buildUrl(WORKSPACE_BASE_URL, {
    path: `/${id}/register`
  })

  const registerInvitationAPI = () => {
    return axios({method: "POST",
      url: url,
      data: user,
    }).then((response) => response.data)
  }; 

  try {
    const response = yield call(registerInvitationAPI);
    yield put(registeringInviteUserSuccedded(response));
    if(callback) {
      callback(response);
    }
  } catch (error) {
    yield put(registeringInviteUserFailed(error.errors));
  }
}


/**
 * Logout User
 */
export const logoutUser = createAction(LOGOUT_USER_REQUEST);

function* logoutUserSaga() {
  AsyncLocalStorageService.removeItem("appId");

  const logoutUserAPI = () => {
    return axios.delete(LOGOUT_URL).then((response) => response.data);
  };

  try {
    yield call(logoutUserAPI);
  } catch (error) {
    console.log(error);
  } finally {
    yield put({ type: LOGOUT_USER, payload: {} });
    AuthService.clearAccessToken();
  }
}

/**
 * Refresh token
 */
export function refreshToken(token) {
  const data = {
    grant_type: "refresh_token",
    refresh_token: token,
  };

  const authorization = btoa("paperflite:paperflite-secret");

  return axios({
    method: "POST",
    url: AUTHORIZE_URL,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Basic ${authorization}`,
    },
    params: data,
  });
}

/**
 * Fetch User
 */
export const fetchUser = createAction(FETCHING_USER_PROFILE);

export const fetchingUserSucceeded = createAction(
  FETCHING_USER_PROFILE_SUCCEEDED,
  (response) => {
    return response;
  }
);

export const fetchingUserFailed = createAction(
  FETCHING_USER_PROFILE_FAILED,
  (error) => {
    return error;
  }
);

function* fetchUserSaga(action) {
  const fetchUserProfile = () => {
    return axios
      .get(PROFILE_URL)
      .then((response) => response.data)
      .catch((err) => {
        throw err;
      });
  };

  try {
    const response = yield call(fetchUserProfile);
    if (response) {
      yield put(fetchingUserSucceeded(response));
    }
  } catch (error) {
    yield put(fetchingUserFailed(error));
  }
}

/**
 * Update Profile
 */

export const updateProfile = createAction(
  UPDATING_USER_PROFILE,
  (request, callback) => {
    return request;
  }
);

const updateProfileSucceeded = createAction(
  UPDATING_USER_PROFILE_SUCCEEDED,
  (response) => {
    return response;
  }
);

const updateProfileFailed = createAction(
  UPDATING_USER_PROFILE_FAILED,
  (error) => {
    return error;
  }
);

function* updateProfileSaga(action) {
  var request = action.payload;

  const updateProfileAPI = () => {
    return axios.put(PROFILE_URL, request).then((response) => response.data);
  };

  try {
    const response = yield call(updateProfileAPI);
    yield put(updateProfileSucceeded(response));
  } catch (error) {
    yield put(updateProfileFailed(error));
  }
}

export default function* userSaga() {
  yield takeLatest(AUTHENTICATING_USER_REQUEST, authenticateUserSaga);
  yield takeLatest(FETCHING_SSO_URL_REQUEST, fetchSSOUrlFromEmailSaga);
  yield takeLatest(FORGOT_PASSWORD_REQUEST, forgotPasswordSaga);
  yield takeLatest(LOGOUT_USER_REQUEST, logoutUserSaga);
  yield takeLatest(FETCHING_USER_PROFILE, fetchUserSaga);
  yield takeLatest(UPDATING_USER_PROFILE, updateProfileSaga);
  yield takeLatest(CHANGING_PASSWORD, changePasswordSaga);
  yield takeLatest(VALIDATING_PASSWORD_RESET_LINK, validateRecoveryLinkSaga);
  yield takeLatest(RESET_PASSWORD_REQUEST, resetPasswordSaga);
  yield takeLatest(FETCHING_USER_INVITATION, fetchUserInvitationSaga);
  yield takeLatest(USER_REGISTRATION_REQUEST, registerInviteUserSaga);
}
